<template>
  <van-form class="add-account" @submit="submit">
    <div class="main">
      <van-field
        label="账户名称"
        input-align="right"
        v-model="params.name"
        placeholder="请输入8个字以内"
        required
        maxlength="8"
        error-message-align="right"
        :rules="[{ required: true, message: '请输入账户名称' }]"
      >
      </van-field>
      <van-field
        label="选择授权校区"
        input-align="right"
        required
        @click="selectCampus"
        :value="params.campusList.length"
        error-message-align="right"
        :rules="[{ validator: val => val > 0, message: '请选择至少一个校区' }]"
      >
        <template #input>
          <span v-if="campusText" class="link van-ellipsis">{{ campusText }}</span>
          <span v-else style="color: var(--g5)">请选择</span>
          <van-icon name="arrow" size="var(--fs-lg)" color="var(--g5)" />
        </template>
      </van-field>

      <div class="campus-area" v-show="params.campusList.length">
        <div class="info-wrapper">
          <div v-for="(i, idx) in params.campusList" :key="idx" class="info-item">
            <van-icon
              name="system_del"
              class-prefix="vxs-icon"
              class="delete-relation"
              size="16"
              @click="delCampus(i)"
            />
            <div class="item-label">{{ i.name }}</div>
          </div>
        </div>
      </div>
      <van-field label="启用状态" input-align="right">
        <template #input>
          <van-switch v-model="params.status" size="20" :active-value="1" :inactive-value="0" @change="warn"/>
        </template>
      </van-field>
      <div class="split" style="height: 12px"></div>

      <van-field
        class="txa"
        type="textarea"
        v-model="params.remark"
        autosize
        rows="2"
        maxlength="200"
        placeholder="请输入备注信息"
        show-word-limit
        input-align="left"
      />
    </div>

    <page-footer-btn multipleBtns>
      <van-button
        square
        round
        block
        type="danger"
        native-type="button"
        style="width: 25%"
        v-if="isEdit"
        @click.stop="delAccount"
      >
        删除
      </van-button>
      <van-button
        square
        round
        block
        type="primary"
        native-type="submit"
        :loading="submiting"
        loading-text="保存中..."
      >
        保存
      </van-button>
    </page-footer-btn>
  </van-form>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

export default {
  name: 'add-account',
  components: {
    pageFooterBtn ,
  },
  data() {
    const isEdit = this.$route.name == 'sf/set/edit-account';
    return {
      pageTitle: isEdit ? '编辑账户' : '新增账户',
      isEdit,
      params: {
        name: '',
        campusIds: [],
        campusList: [],
        remark: '',
        status: 1,
      },
      submiting: false,
    };
  },
  computed: {
    campusText: function () {
      let cps = this.params.campusList,
        text = '';
      if (cps.length == 1) {
        text = cps[0].name;
      } else if (cps.length > 1) {
        text = `${cps.length}个校区`;
      }
      return text;
    },
  },
  methods: {
    async delAccount(){
      await this.$dialog.confirm({
          message: '确认删除该账户吗？',
          confirmButtonText: "确定",
          cancelButtonText: '取消',
        });
      const res = await this.$api.deleteCustomAccount({
        id: +this.$route.params.id
      })
      if (res.code == 200) {
        this.$emitBus('offline-channel-refresh');
        this.$emitBus('refresh-custom-account');
        vant.Toast('删除成功');
        this.$router.back();
      } else if (res.code === 740000004) {
        this.$dialog.alert({
          message: '该账户下有收支记录，不能删除，删除会影响数据统计。建议使用 “停用” 功能。',
          confirmButtonText: "我知道了",
        });
      }
    },
    warn(){
      if (this.params.status == 0) {
        this.$dialog.confirm({
          message: '停用后，将无法使用该账户来收款或记账，但不影响历史数据的编辑和统计，请确认是否停用？',
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }).catch(()=>{
          this.params.status = 1;
        });
      }
    },
    async submit() {
      this.submiting = true;
      const res = await this.$api.editOrAddOffline({
        ...this.params,
      }).finally(()=>{
        this.submiting = false;
      });
      this.$router.back();
      this.$emitBus('offline-channel-refresh');
      this.$emitBus('refresh-custom-account');
    },
    async selectCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList,
      });
      this.params.campusIds = res.ids;
      this.params.campusList = res.list;
    },
    delCampus(index) {
      this.params.campusList.splice(index, 1);
      this.params.campusIds.splice(index, 1);
    },
  },
  async created() {
    if (this.isEdit) {
      const res = await this.$api.paymentAccountInfoById({
        id: this.$route.params.id,
      });
      Object.assign(this.params, res.data);
      this.params.campusIds = res.data.campusList.map(item => item.id);
    }
  },
};
</script>

<style lang="scss" scoped>
.add-account {
  display: flex;
  flex-direction: column;
  height: 100%;
  .main {
    flex: 1;
    overflow: auto;
    background: var(--white);
    .info-wrapper {
      margin-top: calc(var(--gap) * 12);
      padding: 0 calc(var(--gap) * 16);
      font-size: var(--fs-md);
      background-color: var(--white);
      .info-item {
        padding: calc(var(--gap) * 13) 0;
        display: flex;
        align-items: center;
        &:not(:last-child) {
          border-bottom: 0.5px solid var(--g3);
        }
        .delete-relation {
          margin-right: calc(var(--gap) * 8);
          color: var(--c3);
        }
        .item-label {
          white-space: nowrap;
        }
      }
    }
    .split {
      background: var(--g1);
    }
  }
  .link {
    color: var(--c1);
  }
}
</style>